import { create } from "zustand";
import { devtools } from "zustand/middleware";

type Store = {
  isOpen: boolean;
  showModal: () => void;
  closeModal: () => void;
};

export const useSearchNotesStore = create<Store>()(
  devtools(
    (set) => ({
      isOpen: false,
      showModal: () => {
        // BodyNoScroll.Enable();
        // window.scrollTo({ top: 0, behavior: "instant" });
        set(() => ({
          isOpen: true,
        }));
      },
      closeModal: () => {
        // BodyNoScroll.Disable();
        set(() => ({
          isOpen: false,
        }));
      },
    }),
    { name: "SearchNotesStore" },
  ),
);
